import React, { useState } from "react";
import { CustomerViewAdditionalDetailsProps } from "./customer-view-additional-details.props";
import CustomerViewDetailsView from "./customer-view-details-view/customer-view-details-view";
// import CustomerViewDetailsEdit from "./customer-view-details-edit/customer-view-details-edit";
import "./customer-view-additional-details.scss";

const CustomerViewAdditionalDetails: React.FC<CustomerViewAdditionalDetailsProps> = (
  props: any
) => {
  const {
    customerDetails,
    selectedCustomerId,
    setLoading,
    viewEditOpen,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    uploadedImageFile,
    setUploadedImageFile,
    setRemoveImage,
    removeImage,
    fetchCustomerDetails,
    onCustomerNameUpdate,
    resetImageUpload,
    handleFormSubmitError,
    permissions,
    isMobile,
  } = props;
  return (
    <div className="customer-list-view-details-edit-view">
      <div className="customer-list-view-details-view">
        <CustomerViewDetailsView
          customerDetails={customerDetails}
          setLoading={setLoading}
          selectedCustomerId={selectedCustomerId}
          viewEditOpen={viewEditOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          setViewFullInfoOpen={setViewFullInfoOpen}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          uploadedImageFile={uploadedImageFile}
          setUploadedImageFile={setUploadedImageFile}
          setRemoveImage={setRemoveImage}
          removeImage={removeImage}
          fetchCustomerDetails={fetchCustomerDetails}
          onCustomerNameUpdate={onCustomerNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          permissions={permissions}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default CustomerViewAdditionalDetails;
